<p-message
    [id]="id() + '-message'"
    [severity]="severity()"
    [icon]="icon()"
    [closable]="closeable()"
    [styleClass]="variant()">
    @if (text()) {
        {{ text() | translate }}
    }
    <ng-content></ng-content>
</p-message>
